import { DataAmigavel } from "@/shared/utils/datas";
import { Key } from "react";
import { Page, Text, View } from "@react-pdf/renderer";
import { PageFooter } from "./ReportPageFooter";
import { RMovimentoDto } from "@/api.types";
import { chunkArray, corrigeProcessos, formatDate, somarQuantidade, textoCivelCriminal } from "../movimentacao.service";
import { parametrosRelatorioMovimentacoes } from "../components/ModalFiltrosMovimentacoes";
import { stylesMovimentacaoReport } from "../components/movimentacao-report-style";

interface IMyProps {
  dados: RMovimentoDto[];
  parametros: parametrosRelatorioMovimentacoes
}

export function ReportPageDefender({ dados }: IMyProps) {

  const totalGeral = dados.reduce(
    (acc, cur) => acc + cur.recebimentos.reduce((ac2, rec) => ac2 + somarQuantidade(rec.registros), 0),
    0
  );

  return (
    <Page size="A4" style={stylesMovimentacaoReport.page} orientation="portrait">
      <Text style={stylesMovimentacaoReport.title}>Relatório de Movimentações</Text>

      {dados.map((movimento, idx) => (
        <View key={idx} style={stylesMovimentacaoReport.section}>
          <Text style={stylesMovimentacaoReport.header}>{movimento.defensor}</Text>

          {movimento.recebimentos?.map((rec, ridx) => (
            <View key={ridx} style={{ marginBottom: 10 }}>
              <Text>
                Ref: {formatDate(rec.referencia)} - Recebido em:{" "}
                {DataAmigavel(rec.data_recebimento)} -{" "}
                {textoCivelCriminal(rec.civel, rec.criminal)}
              </Text>
              <Text>
                {rec.defensoria} {rec.distrito} {rec.nucleo}
              </Text>

              {chunkArray(rec.registros, 20).map((chunk: any, chunkIndex: Key) => (
                <View key={chunkIndex} style={stylesMovimentacaoReport.table} wrap={false}>
                  <View style={stylesMovimentacaoReport.tableRow}>
                    <Text style={stylesMovimentacaoReport.tableColCTipo}>Tipo</Text>
                    <Text style={stylesMovimentacaoReport.tableColCProcessos}>Processos</Text>
                    <Text style={stylesMovimentacaoReport.tableColCQuantidade}>Qtde.</Text>
                  </View>
                  {chunk.map((reg: any, i: any) => (
                    <View style={stylesMovimentacaoReport.tableRow} key={i}>
                      <Text style={stylesMovimentacaoReport.tableColRTipo}>
                        {reg.tipo}
                        {reg.inicial ? " (inicial)" : ""}
                      </Text>
                      <Text style={stylesMovimentacaoReport.tableColRProcessos} wrap>
                        {corrigeProcessos(reg.processos)}
                      </Text>
                      <Text style={stylesMovimentacaoReport.tableColRQuantidade}>
                        {reg.quantidade}
                      </Text>
                    </View>
                  ))}

                  <View style={stylesMovimentacaoReport.tableRow}>
                    <Text
                      style={[
                        stylesMovimentacaoReport.tableColRTipo,
                        { fontWeight: "bold", width: "90%" },
                      ]}
                    >
                      Total por Local
                    </Text>
                    <Text
                      style={[
                        stylesMovimentacaoReport.tableColRQuantidade,
                        { fontWeight: "bold" },
                      ]}
                    >
                      {somarQuantidade(rec.registros)}
                    </Text>
                  </View>
                </View>
              ))}

              {rec.observacao && <Text>Observação: {rec.observacao}</Text>}
            </View>
          ))}

          <Text>
            Total do(a) Defensor(a):{" "}
            {movimento.recebimentos.reduce((acc, rec) => acc + somarQuantidade(rec.registros), 0)}
          </Text>
        </View>
      ))}

      <Text>
        Total Geral:{" "}
        {Intl.NumberFormat("pt-BR", { style: "decimal" }).format(totalGeral)}
      </Text>

      <PageFooter />
    </Page>
  )
}